import React, {useState} from "react";
import clsx from "clsx";
import {ClickAwayListener, Typography, FormControlLabel, Radio, RadioGroup} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";

export default function EditableBoolean({initValue, field, type, textClasses, inputClasses, onChange, variant}) {
    const [editing, setEditing] = useState(false);
    const {t} = useTranslation();
    const classes = useStyles();
    const v2l = {0:"0",1:"1",null:"null"}
    const l2v = {"0":0,"1":1,"null":null}
    const [value, setValue] = useState(v2l[initValue]);
    const handleEdit = () => setEditing(true);
    const handleUnEdit = () => {
        setEditing(false);
        onChange(l2v[value], field);
    }
    const handleChange = (event) => {
        onChange(l2v[event.target.value], field);
        setValue(event.target.value);
    }
    let label;
    switch (initValue) {
        case "0": case 0: case false: label = t('No');break;
        case "1": case 1: case true: label = t('Yes');break;
        default: label = t('unknown');break;
    }

    const labelClasses =  {
        'label': clsx(classes.label, textClasses ? textClasses.root : null),
        'base': classes.base,
    }
    const radioClasses =  {
        'root': clsx(classes.radio, textClasses ? textClasses.root : null),
    }

    return !editing
        ? <Typography onClick={handleEdit} classes={textClasses} variant={variant}>{label}</Typography>
        : <ClickAwayListener onClickAway={handleUnEdit}>
            <RadioGroup
                aria-label="type"
                onClick={handleChange}
                value={value}
                classes={textClasses}
                row
            >
                <FormControlLabel classes={labelClasses} control={<Radio classes={radioClasses} />} value={"1"}    label={t('Yes')} />
                <FormControlLabel classes={labelClasses} control={<Radio classes={radioClasses} />} value={"0"}    label={t('No')} />
                <FormControlLabel classes={labelClasses} control={<Radio classes={radioClasses} />} value={"null"} label={t('null')} />
            </RadioGroup>
        </ClickAwayListener>
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%'
    },
    label: {

    },
    radio: {
        padding:0
    },
    base: {
        borderWidth: 0,
        padding:0
    },
    input: {
        padding: 0
    }
}));